import React from 'react';
import {
  IconDollarSignCircleFilled,
  IconFileFilled,
  IconHouseFilled,
  IconKeyFilled,
  IconUserFilled,
} from '@zillow/constellation-icons';

export const SectionIntroLabels = [
  {
    icon: <IconUserFilled />,
    label: 'Parties to the lease',
    subLabel: 'Share info about who will be covered by your lease:',
    subLabelDescription: 'Landlord, tenant, additional occupants, guarantor, property manager…',
  },
  {
    icon: <IconHouseFilled />,
    label: 'Property and amenities',
    subLabel: 'Describe the property and the features you want your lease to cover:',
    subLabelDescription: 'Property type, property address, appliances, utilities and services, storage…',
  },
  {
    icon: <IconDollarSignCircleFilled />,
    label: 'Terms and payments',
    subLabel: 'Give us all the details about your rent, such as how and when you would like it paid:',
    subLabelDescription: 'Lease terms and dates, rent details, additional fees, manner of payment…',
  },
  {
    icon: <IconKeyFilled />,
    label: 'Rights and obligations',
    subLabel: 'Outline the other obligations under the agreement, including:',
    subLabelDescription: 'Renters insurance, condo/HOA rules, and other rules specific to your property…',
  },
  {
    icon: <IconFileFilled />,
    label: 'Additional details',
    subLabel: 'Add a bit more info on topics such as:',
    subLabelDescription: 'Smoking, pet, and parking policies…',
  },
];

export const SAVE_CHANGES_TEXT = 'Save changes';
export const NEXT_TO_SECTION_TEXT = 'Save and continue';
export const NEXT_TO_SUMMARY_TEXT = 'Save and review';
export const SAVE_AND_CLOSE_TEXT = 'Save and close';
export const VIEW_SUMMARY = 'View summary';
export const GET_STARTED = 'Get started';
export const SECTION_INTRO_CATEGORY_INDEX = -1;

export enum Transition {
  SlideUp = 'slideUp',
  SlideDown = 'slideDown',
  SlideLeft = 'slideLeft',
  SlideRight = 'slideRight',
}
